module.exports = "mutation UpdateStorefrontMugshot {\n  updateStorefrontMugshot {\n    storefront {\n      ...Storefront\n    }\n  }\n}\n"